/**
 * @generated SignedSource<<05302a519af5b09a32dba43d84211891>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type IntegrationType = "AWS" | "BITBUCKET" | "BUILDKITE" | "CAPABILITIES" | "CLOUDWATCH" | "CONFLUENCE" | "CURSOR" | "DATADOG" | "DEVIN" | "DISCORD" | "ELASTICSEARCH" | "FIREHYDRANT" | "GCP" | "GCP_CLOUD_MONITORING" | "GITHUB" | "GITLAB" | "GRAFANA_CLOUD" | "INCIDENT_IO" | "JIRA" | "LANGFUSE" | "LANGSMITH" | "LINEAR" | "NEW_RELIC" | "NOTION" | "OPENSEARCH" | "OPSGENIE" | "PAGERDUTY" | "PGANALYZE" | "POSTGRESQL" | "PROMETHEUS" | "ROLLBAR" | "ROOTLY" | "SENTRY" | "SLACK" | "SNOWFLAKE" | "SOCKET" | "TEMPORAL" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type OpsgenieIntegration_integration$data = {
  readonly credentials: any;
  readonly id: any;
  readonly integrationType: IntegrationType;
  readonly name: string;
  readonly " $fragmentType": "OpsgenieIntegration_integration";
};
export type OpsgenieIntegration_integration$key = {
  readonly " $data"?: OpsgenieIntegration_integration$data;
  readonly " $fragmentSpreads": FragmentRefs<"OpsgenieIntegration_integration">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OpsgenieIntegration_integration",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "integrationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "credentials",
      "storageKey": null
    }
  ],
  "type": "GraphQLIntegration",
  "abstractKey": null
};

(node as any).hash = "fa8788619e16a7c580517e39c3a60888";

export default node;
